import { render, staticRenderFns } from "./classroomLights.vue?vue&type=template&id=3247cd3c&"
import script from "./classroomLights.vue?vue&type=script&lang=js&"
export * from "./classroomLights.vue?vue&type=script&lang=js&"
import style0 from "./classroomLights.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports